export const title = 'Orders completion';

Share of orders made through the app that were completed (paid) versus those that were not completed.

A not completed order is one that was created but never paid. This includes pending payments
(such as unpaid boleto or Pix), declined payments and cancelled orders.
